import ActionManager from './ActionManager.jsx';

/**
 * Singleton instance of ActionManager
 * This provides a shared instance across the application
 */
const actionManager = new ActionManager();

export default actionManager;